import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
  StatusCode,
  type ProductDetailList,
  REACT_QUERY_KEYS,
} from '@hungryroot/rest';
import {
  getPairing,
  type PairingDetail,
} from '@hungryroot/rest/api/v2/pairings/[id]/get';

export { type PairingDetail as Pairing, type ProductDetailList as Ingredient };

type OptionType = Pick<UseQueryOptions, 'enabled'> & {
  outOfStockOptions?: {
    inventory_date: string;
    origin: number;
  };
};

function usePairingHook(id: number, options: OptionType) {
  return useQuery({
    queryKey: [REACT_QUERY_KEYS.PAIRINGS, id, options.outOfStockOptions],
    queryFn: async () => {
      const resp = await getPairing({
        id,
        ...(options.outOfStockOptions ?? {}),
      });

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    enabled: options.enabled === false || id === 0 ? false : true,
    gcTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    retry: 0,
  });
}

export function usePairing(id: number, options: OptionType = {}) {
  return usePairingHook(id, options);
}
